export const styleOverrides = {
  root: ({ theme }) => ({
    borderColor: theme.palette.border.main,
    opacity: 1,
  }),
};
